module.exports = __webpack_public_path__ + "static/media/EIDEFUT1.b6f8e9ab.png";